












import { Component, Vue } from 'vue-property-decorator'

import ClientsTable from '@/views/clients/components/ClientsTable.vue'
import { getClients, deleteClient } from '@/api/clients'
import { ClientModule } from '@/store/modules/clients'
import { IClient } from '@/api/types-client'

@Component({
  name: 'ClientsAdmin',
  components: {
    ClientsTable
  }
})
export default class extends Vue {
  private total = 0
  private list: IClient[] = []
  private listLoading = true
  private title = 'Loading...'

  private async handleDelete(clientId: number) {
    this.title = 'Deactivating, please wait...'
    await deleteClient(clientId)
    this.getList('all')
  }

  created() {
    this.getList('all')
  }

  private async getList(type: string) {
    this.title = 'Loading, please wait...'
    this.total = 0
    this.listLoading = true
    const response = await getClients()
    this.list = response.data
    ClientModule.loadClients(this.list)
    this.total = this.list.length
    this.listLoading = false
    this.title = this.getTitle(type)
  }

  getTitle(type: string) :string {
    switch (type) {
      case 'all': return 'All Clients'
    }
    return ''
  }
}
